function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.85 13C0.85 6.29038 6.29038 0.85 13 0.85C19.7096 0.85 25.15 6.29038 25.15 13C25.15 19.7096 19.7096 25.15 13 25.15C6.29038 25.15 0.85 19.7096 0.85 13ZM2.72812 13C2.72812 18.6716 7.32837 23.2719 13 23.2719C18.6716 23.2719 23.2719 18.6716 23.2719 13C23.2719 7.32837 18.6716 2.72812 13 2.72812C7.32837 2.72812 2.72812 7.32837 2.72812 13ZM12.1422 9.04487C11.9148 8.81748 11.7871 8.50908 11.7871 8.1875C11.7871 7.86593 11.9148 7.55752 12.1422 7.33013C12.3696 7.10275 12.678 6.975 12.9996 6.975C13.3211 6.975 13.6296 7.10275 13.8569 7.33013C14.0843 7.55752 14.2121 7.86593 14.2121 8.1875C14.2121 8.50908 14.0843 8.81748 13.8569 9.04487C13.6296 9.27225 13.3211 9.4 12.9996 9.4C12.678 9.4 12.3696 9.27225 12.1422 9.04487ZM12.2246 11.4688C12.2246 11.4037 12.2782 11.35 12.3433 11.35H13.6558C13.7209 11.35 13.7746 11.4037 13.7746 11.4688V18.9062C13.7746 18.9713 13.7209 19.025 13.6558 19.025H12.3433C12.2782 19.025 12.2246 18.9713 12.2246 18.9062V11.4688Z",
  fill: "#666666",
  stroke: "white",
  strokeWidth: 0.2
});

var SvgGuidelinesIcon = function SvgGuidelinesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuidelinesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guidelines-icon.363b6c17.svg";
export { ForwardRef as ReactComponent };